import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  initAnalytics,
  processAnalyticsOptOutQuery,
  trackPageView,
} from '../analytics'

export function AnalyticsRouteTracker() {
  const location = useLocation()

  useEffect(() => {
    processAnalyticsOptOutQuery()
    initAnalytics()
  }, [])

  useEffect(() => {
    trackPageView(
      location.pathname + location.search,
      document.title
    )
  }, [location])

  return null
}
